import { Button, ElementProps, Footer, Icon, Journey } from 'journey-ui'
import React, { useContext } from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames'
import { CreditCard, DotsThree, ForkKnife, ShoppingCart } from 'phosphor-react'
import { AppContext } from '../contexts/AppContext'
import { CartItemCount } from './Menu/CartItemCount'

interface Props extends ElementProps<'div'> {

}

const FooterButton = (props) => {
  const { children, activePattern, className } = props
  const router = useRouter()
  const isActive = router.asPath.includes(activePattern)

  return (
    <Button
      {...props}
      className={classNames(className,
        'flex-grow relative flex-col hover:bg-white hover:text-primary space-y-1 rounded-none border-none',
        { 'text-primary': isActive, 'text-gray-500': !isActive })}
    >
      {children}
    </Button>
  )
}

const FooterButtonText = Journey.div('text-xs')

export const AppFooter: React.FC<Props> = (props) => {
  const { setCartModalOpen, order, cartNotifications } = useContext(AppContext)

  return (
    <Footer className={classNames(props.className, 'justify-center p-0 md:hidden sticky bottom-0 app-footer')}>
      <div className="max-w-[1080px] flex w-full">
        <FooterButton href="/menu" activePattern="/menu">
          <Icon src={ForkKnife} />
          <FooterButtonText>Menu</FooterButtonText>
        </FooterButton>
        <FooterButton onClick={() => setCartModalOpen(true)}>
          <Icon src={ShoppingCart} />
          <CartItemCount className="top-0 left-[52%] pt-0.5" />
          <FooterButtonText>
            <span>Cart</span>
          </FooterButtonText>
        </FooterButton>
        {order ? (
          <FooterButton href="/checkout" activePattern="/checkout">
            <Icon src={CreditCard} />
            <FooterButtonText>Checkout</FooterButtonText>
          </FooterButton>
        ) : null}
      </div>
    </Footer>
  )
}
